import { appendFileSync, existsSync, mkdirSync, readFileSync, statSync, writeFileSync } from 'fs';
import { join } from 'path';
import { getCloudGridHome } from './home.js';

const MAX_BYTES = 10 * 1024 * 1024;
const ROTATE_TO  = 5 * 1024 * 1024;

function logPath(): string {
  return join(getCloudGridHome(), 'logs', 'cli.log');
}

export function writeLog(line: string): void {
  const dir = join(getCloudGridHome(), 'logs');
  if (!existsSync(dir)) mkdirSync(dir, { recursive: true });
  const p = logPath();
  try {
    if (existsSync(p) && statSync(p).size > MAX_BYTES) {
      const buf = readFileSync(p);
      writeFileSync(p, buf.subarray(buf.length - ROTATE_TO));
    }
    appendFileSync(p, `[${new Date().toISOString()}] ${line}\n`);
  } catch {
    // Never let log failures break CLI
  }
}
